var p={NONE:"none",S:"1px",M:"2px",L:"4px"},x={NONE:0,S:1,M:2,L:4};export{p as border,x as borderNumber};
